import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { getAuctionEventById } from "services";
import EventFormV2 from "./EventFormV2";

export default function EditEvent() {
  const router = useRouter();
  const { id } = router.query;
  const [event, setEvent] = useState<any>(null);

  useEffect(() => {
    if (id) {
      init(id);
    }
  }, [id]);

  const init = async (id: any) => {
    const data: any = await getAuctionEventById(id);
    setEvent(data);
  };

  return (
    <>
      <div className=" px-customPaddingMobile lg:pl-8 lg:pr-[87px] pb-[80px]">
        <EventFormV2 mode={"edit"} prefillData={event} />
      </div>
    </>
  );
}
